import { Typography } from '@material-ui/core';
import React from 'react';

interface IntroductionProps {
  className: string;
}
const PrintIntroduction = (props: IntroductionProps): JSX.Element => {
  const { className } = props;
  return (
    <div style={{ paddingBottom: '20px' }}>
      <Typography align="justify" className={className} style={{ fontWeight: 'bold' }}>
        {'All parts of this form need to be completed to generate your patient\'s risk of a '}
        Grade ≥ 2 complication.
      </Typography>
    </div>
  );
};

export default PrintIntroduction;
